import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Input } from "@/Components/ui/input";
import { Button } from "@/Components/ui/button";
import { ChevronRight, ArrowLeft } from "lucide-react";
import axiosInstance from '../utils/axiosConfig';
import logo from '../images/pslogo.png';

const ForgotPassword = () => {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [email, setEmail] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError('');
        setSuccess('');

        try {
            const response = await axiosInstance.post('/auth/forgotpassword', { email });

            if (response.data) {
                setSuccess('Er is een e-mail verzonden met instructies om je wachtwoord te resetten.');
                setEmail(''); // Clear the form
            }
        } catch (err) {
            console.log('Forgot password error:', err);

            if (err.response) {
                setError(err.response.data || 'Dit e-mailadres is niet bij ons bekend.');
            } else if (err.request) {
                setError('Kan geen verbinding maken met de server.');
            } else {
                setError('Er is iets misgegaan bij het verzenden van de reset-instructies.');
            }
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50">
            <div className="max-w-md w-full space-y-6 p-8 bg-white rounded-lg shadow-lg relative">
                <div className="absolute left-[15px] top-[-5px] w-[80px]">
                    <img src={logo} />
                </div>
                {/* Header Section */}
                <div className="text-center">
                    <h2 className="text-3xl font-inter text-ps-blue-dark">
                        Wachtwoord vergeten
                    </h2>
                    <p className="mt-2 text-sm text-gray-600 font-inter">
                        Vul je e-mailadres in om je wachtwoord te resetten
                    </p>
                </div>

                {/* Form Section */}
                <form onSubmit={handleSubmit} className="mt-8 space-y-6">
                    {/* Error Display */}
                    {error && (
                        <div className="text-red-600 text-sm text-center bg-red-50 p-3 rounded font-inter">
                            {error}
                        </div>
                    )}

                    {/* Success Display */}
                    {success && (
                        <div className="text-green-600 text-sm text-center bg-green-50 p-3 rounded font-inter">
                            {success}
                        </div>
                    )}

                    {/* Email Field */}
                    <div>
                        <label className="block text-sm font-inter text-ps-blue-dark mb-2">
                            E-mailadres
                        </label>
                        <Input
                            type="email"
                            required
                            value={email}
                            onChange={(e) => {
                                setEmail(e.target.value);
                                setError('');
                                setSuccess('');
                            }}
                            className="w-full p-2 border rounded bg-white font-inter"
                            placeholder="naam@bedrijf.nl"
                        />
                    </div>

                    {/* Submit Button */}
                    <div>
                        <Button
                            type="submit"
                            disabled={isLoading}
                            className="w-full bg-ps-blue-dark hover:opacity-80 text-white flex items-center justify-center gap-2 h-12 font-inter"
                        >
                            {isLoading ? 'Bezig met verzenden...' : 'Verstuur reset-link'}
                            <ChevronRight className="h-4 w-4" />
                        </Button>
                    </div>

                    {/* Back to Login */}
                    <div className="text-center">
                        <Button
                            type="button"
                            variant="link"
                            onClick={() => navigate('/')}
                            className="text-ps-blue-dark hover:text-ps-blue font-medium flex items-center justify-center gap-2"
                        >
                            <ArrowLeft className="h-4 w-4" />
                            Terug naar inloggen
                        </Button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ForgotPassword;